/**
 * Core
 */
import React from "react";
/**
 * Styles
 */
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  onFocus,
  id,
  value,
  onBlur,
}) {
  return (
    <input
      autoComplete="off"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      id={id}
      onBlur={onBlur}
      value={value}
    />
  );
}

export default InputGlobal;
